export default function CTA() {
  return (
    <section id="contact" className="relative py-16 md:py-32 w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/78d634d0182effed8c2ceef227ef2d2f.jpg"
          alt="背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/95 via-slate-900/90 to-slate-800/95"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Gold accent lines */}
        <div className="absolute top-0 left-1/4 w-px h-40 bg-gradient-to-b from-amber-400/40 to-transparent"></div>
        <div className="absolute top-0 right-1/3 w-px h-32 bg-gradient-to-b from-amber-400/30 to-transparent"></div>
        <div className="absolute bottom-0 right-1/4 w-px h-40 bg-gradient-to-t from-amber-400/40 to-transparent"></div>
        
        {/* Geometric shapes */}
        <div className="absolute top-20 right-20 w-64 h-64 border border-amber-400/10 rounded-full"></div>
        <div className="absolute bottom-20 left-20 w-48 h-48 border border-white/5 rounded-full"></div>
        
        {/* Floating dots */}
        <div className="absolute top-1/4 right-1/4 w-2 h-2 bg-amber-400/50 rounded-full animate-pulse"></div>
        <div className="absolute bottom-1/3 left-1/3 w-1.5 h-1.5 bg-amber-400/40 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        
        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-[0.02]" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-3 px-4 py-2 bg-amber-400/10 backdrop-blur-sm rounded-full mb-8 border border-amber-400/20">
            <span className="w-2 h-2 bg-amber-400 rounded-full animate-pulse"></span>
            <span className="text-amber-400 text-xs font-medium tracking-widest" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              CONTACT US
            </span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white leading-tight mb-6 md:mb-8" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            まずは<span className="bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 bg-clip-text text-transparent">無料相談</span>から<br />
            はじめませんか
          </h2>
          <p className="text-slate-300 text-sm md:text-lg leading-relaxed">
            経験豊富なコンサルタントが、御社の課題をヒアリングし、<br className="hidden sm:block" />
            最適なソリューションをご提案いたします。
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 md:gap-5 mb-12 md:mb-20">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfVYoouDKvGvHtiBtpwv_mSEhksA7sWsE9SgMdFO4AseAVcfg/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 md:gap-4 px-8 md:px-10 py-4 md:py-5 bg-gradient-to-r from-amber-400 to-amber-500 text-slate-900 rounded-xl hover:from-amber-300 hover:to-amber-400 transition-all whitespace-nowrap cursor-pointer text-base md:text-lg font-semibold shadow-xl shadow-amber-400/20 hover:shadow-amber-400/30 hover:-translate-y-1 w-full sm:w-auto justify-center"
          >
            <span>無料相談を申し込む</span>
            <div className="w-8 h-8 md:w-10 md:h-10 bg-slate-900/10 rounded-full flex items-center justify-center group-hover:bg-slate-900/20 transition-colors">
              <i className="ri-arrow-right-line text-slate-900 group-hover:translate-x-1 transition-transform"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
